import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-protecion_civil',
  templateUrl: './protecion_civil.component.html',
  styleUrls: ['./protecion_civil.component.css']
})
export class Protecion_civilComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
